import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Tooltip } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

const KeyNames = ({ data }) => {
  const { t } = useTranslation(['promptbar']);

  return (
    <>
      {data?.name ? (
        <Box
          sx={{
            width: 'calc(100% - 10px)',
          }}
        >
          <span
            style={{
              fontStyle: data?.is_custom_name ? 'italic' : 'normal',
            }}
          >
            {data.name}
          </span>
          {data?.is_custom_name && (
            <Tooltip title={t('promptbar:customName')} arrow>
              <PersonIcon
                sx={{
                  position: 'absolute',
                  top: '3px',
                  right: '2px',
                  fontSize: 16,
                  color: 'var(--color-primary)',
                }}
              />
            </Tooltip>
          )}
        </Box>
      ) : (
        ''
      )}
    </>
  );
};

KeyNames.propTypes = {
  data: PropTypes.object,
};

export default KeyNames;
